export const GET_MENUBYPERMISSIONS = 'navbar.menu.GET_MENUBYPERMISSIONS';

export const SET_MENU = 'navbar.menu.SET_MENU';
export const SET_MENUSEARCH = 'navbar.menu.SET_MENUSEARCH';

export const TOGGLE_MENU = 'navbar.menu.TOGGLE_MENU';
export const LOCK_MENU = 'navbar.menu.LOCK_MENU';

export const FETCH_SYSTEMSBYUSER = 'navbar.systems.FETCH_SYSTEMSBYUSER';
export const SET_SYSTEMS = 'navbar.systems.SET_SYSTEMS';

export const FETCH_LASTACCESSBYUSER = 'navbar.user.FETCH_LASTACCESSBYUSER';
export const SET_LASTACCESS = 'navbar.user.FETCH_LASTACCESS';

export const UPDATE_PASSWORD = 'navbar.user.UPDATE_PASSWORD';
export const LOGOUT = 'navbar.user.LOGOUT';

export const GET_FAVORITOS = 'navbar.favorite.GET_FAVORITOS';
export const SET_FAVORITOS = 'navbar.favorite.SET_FAVORITOS';
export const ICON_FAVORITOS = 'navbar.favorite.ICON';

export const SET_PAGES_NOTIFICATION = 'navbar.notification.SET_PAGES';
export const SET_READPAGES_NOTIFICATION = 'navbar.notification.SET_READPAGES';
export const GET_PAGES_NOTIFICATION = 'navbar.notification.GET_PAGES';
export const GET_TOTAL_NOTIFICATION = 'navbar.notification.GET_TOTAL';
export const GET_NEW_NOTIFICATION = 'navbar.notification.GET_NEW';
export const GET_READ_NOTIFICATION = 'navbar.notification.GET_READ';
export const SET_NEW_NOTIFICATION = 'navbar.notification.SET_NEW';
export const GET_ALL_NOTIFICATION = 'navbar.notification.GET_ALL_NOTIFICATION';
export const SET_NOTIFICATION = 'navbar.notification.SET_NOTIFICATION';
export const GET_ALL_NOTIFICATION_GRID = 'navbar.notification.GET_ALL_NOTIFICATION_GRID';
export const READ_NOTIFICATION_GRID = 'navbar.notification.READ_NOTIFICATION_GRID';
export const UNREAD_NOTIFICATION = 'navbar.notification.UNREAD_NOTIFICATION';
export const READ_ALL_NOTIFICATION = 'navbar.notification.READ_ALL_NOTIFICATION';
export const DELETE_NOTIFICATION = 'navbar.notification.DELETE_NOTIFICATION';

export const GET_INFO_ABOUT = 'navbar.about.GET_INFO_ABOUT';
export const UPDATE_INFO_ABOUT = 'navbar.about.UPDATE_INFO_ABOUT';
export const SET_FAVORITOS_SELECIONADOS = 'navbar.about.SET_FAVORITOS_SELECIONADOS';
export const REMOVE_PAGE_FROM_FAVORITE = 'navbar.about.REMOVE_PAGE_FROM_FAVORITE';
